/* eslint-disable no-unused-vars */
import appConfig from "@/config/appConfig";
import { flare } from "@flareapp/js";
import { Button, Checkbox, Form, Input, InputNumber, Select, Spin } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

const subType = ["Business", "Personal", "NGO / Not-for-Profit", "Partnership"];

const CreateOrEditPlan = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const Params = useParams();
  const [form] = Form.useForm();

  const [isLoading, setIsLoading] = useState(false);
  const [initValue, setInitValue] = useState({ isCustomerReportAllow: false });
  const [prepaidPlanData, setPrepaidPlanData] = useState({
    name: "",
    planType: "",
    subscriptionType: "",
    price: "",
    currency: "",
    siteAdminCount: "",
    siteUserCount: "",
    sitePublicCount: "",
    installerCount: "",
    locationCount: "",
    deviceCount: "",
    dashboardCount: "",
    storageCount: "",
    isCustomerReportAllow: false,
    isCreateDashboardAllow: false,
  });
  const {
    name,
    planType,
    subscriptionType,
    price,
    currency,
    siteAdminCount,
    siteUserCount,
    sitePublicCount,
    installerCount,
    locationCount,
    deviceCount,
    dashboardCount,
    storageCount,
    isCustomerReportAllow,
  } = prepaidPlanData;

  const planId = Params.planId;
  const isEditing = location.pathname.includes("edit-plan");

  const onInputChange = (e) => {
    let { value, name } = e.target;
    if (name === "planType" && value === "Free") {
      setPrepaidPlanData({ ...prepaidPlanData, [name]: value, price: "", currency: "" });
    } else setPrepaidPlanData({ ...prepaidPlanData, [name]: value });
  };
  const onNumberInputChange = (e) => {
    let { value, name } = e.target;
    value = value.replace(/\D/g, "");
    if (value) value = Number(value);
    setPrepaidPlanData({ ...prepaidPlanData, [name]: value });
  };

  const editSubscriptionPlan = async () => {
    const { _id, createdAt, updatedAt, __v, ...body } = prepaidPlanData;
    try {
      await axios.put(`/subscription/` + planId, body, {
        withCredentials: true,
      });
      Swal.fire({
        title: "Done!",
        text: "Subscription Plan Edited Successfully.",
        icon: "success",
        timer: 2000,
        confirmButtonText: "OK",
      });
      setTimeout(() => {
        navigate(`/view-plan/${planId}`);
      }, 2000);
    } catch (error) {
      flare.report(error);
      Swal.fire({
        title: "",
        text: "Something went wrong",
        icon: "error",
        timer: 2000,
        confirmButtonText: "OK",
      });
    }
  };

  const createSubscriptionPlan = async () => {
    try {
      const response = await axios.post(`/subscription`, prepaidPlanData, { withCredentials: true });
      const data = response?.data;
      if (data) {
        await Swal.fire({
          title: "Done!",
          text: "Subscription Plan Created Successfully",
          icon: "success",
          timer: 2000,
          confirmButtonText: "OK",
        });
        navigate("/plan-list");
      }
    } catch (error) {
      flare.report(error);
      Swal.fire({
        title: "",
        text: error.response?.data?.message || "Something went wrong.",
        icon: "error",
        timer: 2000,
        confirmButtonText: "OK",
      });
    }
  };
  const onFinish = async () => {
    setIsLoading(true);
    if (isEditing) {
      await editSubscriptionPlan();
    } else {
      await createSubscriptionPlan();
    }
    setIsLoading(false);
  };

  const getPrepaidPlan = async () => {
    const response = await axios.get(`/subscription/` + planId, {
      withCredentials: true,
    });
    if (response) {
      const data = response.data;
      form.setFieldsValue(data);
      setPrepaidPlanData((prev) => ({ ...prev, ...data }));
    }
  };

  useEffect(() => {
    document.title = appConfig.name + " - Subscription";
    if (isEditing) {
      getPrepaidPlan();
    }
  }, [isEditing, planId]);

  const onFinishFailed = (errorInfo) => {
    // eslint-disable-next-line no-console
    console.log("Failed:", errorInfo);
  };

  return (
    <Spin spinning={isLoading}>
      <div className="az-content-body subscription_form">
        <div className="row row-sm mg-b-15 mg-sm-b-20">
          <div className="col-lg-12">
            <div className="card card-dashboard-six">
              <div className="card-header">
                <div className="col-md-8 p-0">
                  <label className="az-content-label">Manage Subscription Plan</label>
                  <span className="d-block py-2">{isEditing ? "Edit" : "Create New"} Subscription Plan</span>
                </div>
              </div>

              {(isEditing && initValue) || !isEditing ? (
                <Form
                  layout="vertical"
                  name="users"
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  form={form}
                  onValuesChange={(_, values) => setPrepaidPlanData(values)}
                  initialValues={{ ...initValue }}
                  scrollToFirstError={true}
                >
                  <Row>
                    <Col md={6}>
                      <p className="az-content-label">General Information</p>
                      <Form.Item
                        label="Subscription Plan Name"
                        name="name"
                        rules={[{ required: true, message: "Enter Subscription Plan Name" }]}
                      >
                        <Input placeholder="Enter Subscription Plan Name" />
                      </Form.Item>

                      <Form.Item
                        label="Plan Type"
                        name="planType"
                        rules={[{ required: true, message: "Select Plan Type" }]}
                      >
                        <Select
                          onChange={(value) => setPrepaidPlanData((pre) => ({ ...pre, planType: value }))}
                          showSearch={true}
                          filterOption={(input, option) =>
                            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                          }
                          placeholder="Select Plan Type"
                          className="w-100"
                          options={["Paid", "Free"].map((i) => ({ value: i, label: i }))}
                        />
                      </Form.Item>

                      <Form.Item
                        label="Subscription Type"
                        name="subscriptionType"
                        rules={[{ required: true, message: "Select Subscription Type" }]}
                      >
                        <Select
                          // onChange={(value) => setprepaidPlanData({ ...prepaidPlanData, subscriptionType: value })}

                          showSearch={true}
                          filterOption={(input, option) =>
                            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                          }
                          placeholder="Select Subscription Type"
                          className="w-100"
                          options={subType.map((sub) => ({ label: sub, value: sub }))}
                        />
                      </Form.Item>

                      <Form.Item
                        label="Currency"
                        name="currency"
                        rules={[{ required: planType !== "Free", message: "Set Currency" }]}
                      >
                        <Input placeholder="Set Currency" disabled={planType === "Free"} />
                      </Form.Item>

                      <Form.Item
                        label="Per Device Price"
                        name="price"
                        rules={[{ required: planType !== "Free", message: "Enter Per Device Price" }]}
                      >
                        <InputNumber
                          className="w-100"
                          placeholder="Enter Per Device Price"
                          disabled={planType === "Free"}
                        />
                      </Form.Item>
                    </Col>
                    <Col md={6}>
                      <p className="az-content-label">General Information</p>

                      <Form.Item
                        label="Total Site Admin Users"
                        name="siteAdminCount"
                        rules={[
                          { required: true, message: "Enter Maximum Quantity of Site Admin Users" },
                          {
                            pattern: /^[0-9]+$/,
                            message: "Please Enter a Positive Integer Only",
                          },
                        ]}
                      >
                        <Input placeholder="Enter Maximum Quantity of Site Admin Users" />
                      </Form.Item>

                      <Form.Item
                        label="Total Site Users"
                        name="siteUserCount"
                        rules={[
                          { required: true, message: "Enter Maximum Quantity of Site Users" },
                          {
                            pattern: /^[0-9]+$/,
                            message: "Please Enter a Positive Integer Only",
                          },
                        ]}
                      >
                        <Input placeholder="Enter Maximum Quantity of Site Users" />
                      </Form.Item>

                      <Form.Item
                        label="Total Public Users"
                        name="sitePublicCount"
                        rules={[
                          { required: true, message: "Enter Maximum Quantity of Public Users" },
                          {
                            pattern: /^[0-9]+$/,
                            message: "Please Enter a Positive Integer Only",
                          },
                        ]}
                      >
                        <Input placeholder="Enter Maximum Quantity of Public Users" />
                      </Form.Item>

                      <Form.Item
                        label="Total Installer Users"
                        name="installerCount"
                        rules={[
                          { required: true, message: "Enter Maximum Quantity of Installer Users" },
                          {
                            pattern: /^[0-9]+$/,
                            message: "Please Enter a Positive Integer Only",
                          },
                        ]}
                      >
                        <Input placeholder="Enter Maximum Quantity of Installer Users" />
                      </Form.Item>

                      <Form.Item
                        label="Total Locations"
                        name="locationCount"
                        rules={[
                          { required: true, message: "Enter Maximum Quantity of Locations" },
                          {
                            pattern: /^[0-9]+$/,
                            message: "Please Enter a Positive Integer Only",
                          },
                        ]}
                      >
                        <Input placeholder="Enter Maximum Quantity of Locations" />
                      </Form.Item>

                      <Form.Item
                        label="Total Devices"
                        name="deviceCount"
                        rules={[
                          { required: true, message: "Enter Maximum Quantity of Devices" },
                          {
                            pattern: /^[0-9]+$/,
                            message: "Please Enter a Positive Integer Only",
                          },
                        ]}
                      >
                        <Input placeholder="Enter Maximum Quantity of Devices" />
                      </Form.Item>

                      <Form.Item
                        label="Total Dashboards"
                        name="dashboardCount"
                        rules={[
                          { required: true, message: "Enter Maximum Quantity of Dashboards" },
                          {
                            pattern: /^[0-9]+$/,
                            message: "Please Enter a Positive Integer Only",
                          },
                        ]}
                      >
                        <Input placeholder="Enter Maximum Quantity of Dashboards" />
                      </Form.Item>

                      {/* <Form.Item
                        label="Total Hosting Year"
                        name="storageCount"
                        rules={[{ required: true, message: "Enter Maximum Year of Size" }]}
                      >
                        <Input placeholder="Enter Maximum Year of Size" />
                      </Form.Item> */}

                      <p className="az-content-label">PREMIUM FEATURES</p>
                      <Form.Item
                        name="isCustomerReportAllow"
                        valuePropName="checked"
                        labelHeight="24px"
                        // rules={[{ required: true, message: "" }]}
                      >
                        <Checkbox>Custom Reports</Checkbox>
                      </Form.Item>

                      <Form.Item
                        name="isCreateDashboardAllow"
                        valuePropName="checked"
                        labelHeight="15px"
                        // rules={[{ required: true, message: "" }]}
                      >
                        <Checkbox>Create Dashboard</Checkbox>
                      </Form.Item>
                    </Col>
                  </Row>

                  {/* submit button */}

                  <div className="d-flex align-items-center justify-content-end gap-2 pt-2">
                    <Button type="primary" htmlType="submit">
                      {isEditing ? "Update" : "Create "} Subscription Plan
                    </Button>
                    <Button type="primary" className="bg-secondary" onClick={() => navigate(-1)} htmlType="button">
                      Cancel
                    </Button>
                  </div>
                </Form>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default CreateOrEditPlan;
